import React, { useState, useEffect, useRef } from 'react';

import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';
import dayjs from "dayjs";
import Calendar from '../../../components/calendar/Calendar.js';
import ScrollToTopButton from '../../../components/extra/ScrollToTopButton.js';

function HistoricalAlarm(props) {
    const formremarkRef = useRef(null)
    const eventclassRef = useRef(null)

    const [data_uioption, setData_uioption] = useState({
        device_selector: [],
    });
    const [reportdate_dt_begin, setReportdate_dt_begin] = useState(dayjs(dayjs(new Date()).format("YYYY-MM-DD")));
    const [reportdate_dt_end, setReportdate_dt_end] = useState(dayjs(dayjs(new Date()).format("YYYY-MM-DD")));
    const [filter, setFilter] = useState({
        event_plant: 'All',
        event_class: 'All',
        event_device: 'All',
        sort: 'desc'
    });
    const [exportfilename, setExportFileName] = useState('');
    const [data_alarmevent, setData_alarmevent] = useState([])
    const [remark_display_id, setRemark_display_id] = useState('')

    const [modal_remark, setModal_remark] = useState(false);
    const [remark_item, setRemark_item] = useState({
        Event_ID: '',
        Event_DateTimeStamp_Active: '',
        Event_Class: '',
        Event_Source: '',
        Event_Tagname: '',
        Event_Category: '',
        Remark: '',
    })

    const onCalendaraChange_begin = (date, dateString) => {
        setReportdate_dt_begin(date)
    };

    const onCalendaraChange_end = (date, dateString) => {
        setReportdate_dt_end(date)
    };

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    useEffect(() => {
        return () => {
            setData_alarmevent([])
        };
    }, []);

    useEffect(() => {
        if (filter.event_device === "PLC" || filter.event_device === "Environment" || filter.event_device === "Grid Meter" || filter.event_device === "Server" || filter.event_device.includes("Solar Meter")) {
            eventclassRef.current.disabled = true
        } else {
            eventclassRef.current.disabled = false
            setFilter({
                ...filter,
                event_class: "All"
            })
        }
    }, [filter.event_device]);

    useEffect(() => {
        if (props.data_uioption !== undefined) {
            if (props.data_uioption.device_selector !== null && props.data_uioption.device_selector !== undefined) {
                setData_uioption(props.data_uioption)
            }
        }
    }, [props.data_uioption]);

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    async function api_query() {
        const diff = reportdate_dt_end.diff(reportdate_dt_begin, 'days')
        if (diff >= 0) {
            if (diff < 2) {
                const dt_begin = dayjs(new Date(reportdate_dt_begin)).format("YYYY-MM-DD")
                const dt_end = dayjs(new Date(reportdate_dt_end)).format("YYYY-MM-DD")
                const formData = new FormData();
                formData.append('reportdate_begin', dt_begin)
                formData.append('reportdate_end', dt_end)
                formData.append('event_class', filter.event_class)
                formData.append('event_device', filter.event_device)
                formData.append('sort', filter.sort)

                setmodal_load({ enable: true, message: "Querying alarm & event data..." })
                await sleep(500)

                axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/alarmevent/historical", formData, {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'multipart/form-data;',
                        "Authorization": "Bearer " + props.permitdata.token
                    },
                })
                    .then((response) => {
                        setmodal_load({ enable: false, message: "" })
                        if (response.data.status === 'OK') {
                            setData_alarmevent(response.data.alarm)
                            setExportFileName(response.data.filename)
                        }
                        else {
                            setModal_popup({
                                modaltype: 'modal-error',
                                headers: 'Error',
                                message: response.data.message,
                                enable: true
                            });
                            setData_alarmevent([])
                            setExportFileName('')
                        }

                    })
                    .catch((err) => {
                        setData_alarmevent([])
                        setExportFileName('')
                        setmodal_load({ enable: false, message: "" })
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: err.message,
                            enable: true
                        });
                    });
            } else {
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: 'Duration between Date begin and date end must be less than or equal 2 days !',
                    enable: true
                });
            }
        } else {
            setModal_popup({
                modaltype: 'modal-error',
                headers: 'Error',
                message: 'Date end must be greather than or equal date begin !',
                enable: true
            });
        }
    }

    async function api_saveremark() {
        var formelement = formremarkRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");
            const formData = new FormData();
            formData.append('event_id', remark_item.Event_ID)
            formData.append('remark_text', remark_item.Remark)

            setmodal_load({ enable: true, message: "Saving alarm event remark." })
            await sleep(500)

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/alarmevent/remark", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_remark(false)
                    setRemark_item({
                        Event_ID: '',
                        Event_DateTimeStamp_Active: '',
                        Event_Class: '',
                        Event_Source: '',
                        Event_Tagname: '',
                        Event_Category: '',
                        Remark: '',
                    })
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your alarm event remark has been saved to database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.remark !== undefined) {
                        const nextalarm = data_alarmevent.map(alarm => {
                            if (alarm.Event_ID === response.data.event_id) {
                                return {
                                    ...alarm,
                                    Remark: response.data.remark,
                                };
                            } else {
                                return alarm;
                            }
                        });
                        setData_alarmevent(nextalarm)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_remark(false)
                    setRemark_item({
                        Event_ID: '',
                        Event_DateTimeStamp_Active: '',
                        Event_Class: '',
                        Event_Source: '',
                        Event_Tagname: '',
                        Event_Category: '',
                        Remark: '',
                    })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }


    function alarm_record_bg_color(data) {
        if (data.Event_Class === "Critical" || data.Event_Class === "Major") {
            if (data.Ack_Req) {
                if (data.Ack_Status) {
                    if (data.Event_Status) {
                        return "alarmevent-bg-red"
                    } else {
                        return ""
                    }
                } else {
                    return "alarmevent-blink-bg-red"
                }
            } else {
                if (data.Event_Status) {
                    return "alarmevent-blink-bg-red"
                } else {
                    return ""
                }
            }
        } else if (data.Event_Class === "Minor") {
            if (data.Ack_Req) {
                if (data.Ack_Status) {
                    if (data.Event_Status) {
                        return "alarmevent-bg-orange"
                    } else {
                        return ""
                    }
                } else {
                    return "alarmevent-blink-bg-orange"
                }
            } else {
                if (data.Event_Status) {
                    return "alarmevent-blink-bg-orange"
                } else {
                    return ""
                }
            }
        } else if (data.Event_Class === "Warning") {
            if (data.Ack_Req) {
                if (data.Ack_Status) {
                    if (data.Event_Status) {
                        return "alarmevent-bg-yellowe"
                    } else {
                        return ""
                    }
                } else {
                    return "alarmevent-blink-bg-yellow "
                }
            } else {
                if (data.Event_Status) {
                    return "alarmevent-blink-bg-yellow "
                } else {
                    return ""
                }
            }
        } else if (data.Event_Class === "Info") {
            return ""
        } else if (data.Event_Class === "System") {
            return ""
        }
    }

    function export_csv() {
        if (data_alarmevent.length > 0) {
            var tableheader = ['Event DateTime Active', 'Event DateTime InActive', 'Event Class', 'Event Device', 'Event Tags', 'Category', 'Status', 'Ack. Status', 'Message']

            const tableData = [];
            tableData.push(tableheader.join(","));
            const rows = document.querySelectorAll("table.table-alarm tbody tr");
            for (const row of rows) {
                const rowData = [];
                for (const [index, column] of row.querySelectorAll("th, td").entries()) {
                    if (index < 16) {
                        var tdata = column.innerText.replaceAll(",", "")
                        rowData.push(tdata);
                    }
                }
                tableData.push(rowData.join(","));
            }

            let data = tableData.join("\n");
            const a = document.createElement("a");
            a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
            var fnamey = exportfilename + '.csv'
            a.setAttribute("download", fnamey);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            setModal_popup({
                modaltype: 'modal-warning',
                headers: 'Warning',
                message: "No data to export!",
                enable: true
            })
        }
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-alert-rhombus-outline color-orange"></i> Historical Alarm & Event</h4>
                                    <p className="mb-0">Tracking your events with filtering tools.</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="reportdate_dt" className="form-label mb-0">Select Date Begin</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange_begin}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt_begin}
                            />
                        </div>
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="reporttype" className="form-label mb-0">Select Date End</label>
                            <Calendar
                                allowClear={false}
                                className={"form-control"}
                                onChange={onCalendaraChange_end}
                                style={{
                                    fontFamily: "poppins",
                                    fontSize: "0.75rem",
                                    Color: "black",
                                    lineHeight: "1.5",
                                    cursor: "pointer",
                                }}
                                value={reportdate_dt_end}
                            />
                        </div>
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="event_device" className="form-label mb-0">Event Device</label>
                            <select id="event_device" name="event_device" className="form-select" value={filter.event_device} onChange={(e) => {
                                setFilter({
                                    ...filter,
                                    event_device: e.target.value
                                })
                            }} required>
                                {
                                    data_uioption.device_selector.map((device, index) => (
                                        <option key={device.device_id} value={device.device_id}>{device.device_id}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="event_class" className="form-label mb-0">Event Class</label>
                            <select ref={eventclassRef} name="event_class" className="form-select" value={filter.event_class} onChange={(e) => {
                                setFilter({
                                    ...filter,
                                    event_class: e.target.value
                                })
                            }} required>
                                <option value="All">All</option>
                                <option value="Critical">Critical</option>
                                <option value="Major">Major</option>
                                <option value="Minor">Minor</option>
                                <option value="Warning">Warning</option>
                                <option value="Hints">Hints</option>
                                <option value="Info">Info</option>
                            </select>
                        </div>
                        <div className="d-block" style={{ width: "160px" }}>
                            <label htmlFor="sort" className="form-label mb-0">Sort Type</label>
                            <select id="sort" name="sort" className="form-select" value={filter.sort} onChange={(e) => {
                                setFilter({
                                    ...filter,
                                    sort: e.target.value
                                })
                            }} required>
                                <option value="desc">Descending</option>
                                <option value="asc">Ascending</option>
                            </select>
                        </div>
                        <div className='d-flex'>
                            <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                <button className="btn btn-info btn-sm me-5" onClick={() => { api_query() }}><i className="fas fa-search "></i> Query</button>
                            </div>
                            <div className="d-block align-self-end print-disable">
                                <div className="d-flex gap-1 mt-3 mt-xl-0" style={{ marginBottom: "3px" }}>
                                    <button className="btn btn-secondary btn-sm " onClick={() => { export_csv() }}><i className="fas fa-file-csv "></i> Export CSV</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-2 mb-1 mb-md-4">
                        <div className='d-flex justify-content-between flex-wrap mb-2'>
                            <div className='align-text-bottom py-0 my-0'><h5 className='py-0 my-0 text-center'>Historical Query Result</h5></div>
                        </div>
                        <div className="d-block ">
                            <h6 className='py-0 mb-1 '>Banner Color Definition (Only Active State)</h6>
                            <div className='d-flex gap-3 flex-wrap mt-0'>
                                <p className='mb-0 mt-0'><i className='mdi mdi-rectangle alarmevent-text-red'></i>Critical, Major</p>
                                <p className='mb-0 mt-0'><i className='mdi mdi-rectangle alarmevent-text-orange'></i>Minor</p>
                                <p className='mb-0 mt-0'><i className='mdi mdi-rectangle text-yellow'></i>Warning</p>
                            </div>
                        </div>
                        <div className="d-block mt-2">
                            <h6 className='py-0 my-0 mb-1'>Events Symbol Definition</h6>
                            <div className='d-flex gap-2 gap-xl-3 flex-wrap mt-0 mb-0'>
                                <p className='mb-0 mt-0 py-0'><i className='fas fa-bell text-danger'></i> Critical, Major Active</p>
                                <p className='mb-0 mt-0 py-0'><i className='fas fa-bell text-warning'></i> Minor Active</p>
                                <p className='mb-0 mt-0 py-0'><i className='fas fa-bell text-yellow'></i> Warning Active</p>
                                <p className='mb-0 mt-0 py-0'><i className='fas fa-bell alarmevent-text-green'></i> Critical, Major, Minor, Warning Recover</p>
                                <p className='mb-0 mt-0 py-0'><i className='fas fa-bell-slash rows-icon'></i> Critical, Major, Minor, Warning InActive</p>
                                <p className='mb-0 mt-0 py-0'><i className='fas fa-info-circle alarmevent-text-blue'></i> Events Info</p>
                            </div>
                        </div>

                        <div className="table-responsive mt-1">
                            <table className="table table-bordered table-alarm text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>Event Class</th>
                                        <th>Event DateTime Active</th>
                                        <th>Event DateTime InActive</th>
                                        <th>Event Device</th>
                                        {/* <th>Event Tags</th> */}
                                        <th>Category</th>
                                        <th>Status</th>
                                        <th>Acknowledge Status</th>
                                        <th>Message</th>
                                        {
                                            props.permitdata !== undefined ?
                                                props.permitdata.user_role !== "Viewer" ?
                                                    <th width={"50px"}></th>
                                                    :
                                                    null
                                                : null
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data_alarmevent.map((data, index) => (
                                            <tr key={data.Event_ID} className={"" + alarm_record_bg_color(data)}>
                                                <td className='font-sarabun'>
                                                    <div className='alarm-icon'>
                                                        <i className={"me-2 "
                                                            + ((data.Event_Class === "Critical" || data.Event_Class === "Major") && data.Event_Status === true ?
                                                                "fas fa-bell text-danger"
                                                                : data.Event_Class === "Minor" && data.Event_Status === true ?
                                                                    "fas fa-bell text-warning"
                                                                    : data.Event_Class === "Warning" && data.Event_Status === true ?
                                                                        "fas fa-bell text-yellow"
                                                                        : (data.Event_Class === "Critical" || data.Event_Class === "Major" || data.Event_Class === "Minor" || data.Event_Class === "Warning") && data.Event_Status === false ?
                                                                            "fas fa-bell-slash rows-icon"
                                                                            : data.Event_Class === "Info" || data.Event_Class === "Hints" ?
                                                                                "fas fa-info-circle text-info"
                                                                                : data.Event_Class === "Recover" ?
                                                                                    "fas fa-bell alarmevent-text-green"
                                                                                    : "fas fa-bell rows-icon"
                                                            )}></i>
                                                    </div>
                                                    {data.Event_Class}
                                                </td>
                                                <td className='font-sarabun table-rows-min-h'>
                                                    {data.Event_DateTimeStamp_Active}
                                                </td>
                                                {
                                                    data.Event_Class === "Info" || data.Event_Class === "Recover" || data.Device_Type === "Server" ?
                                                        <td className='font-sarabun'>-</td>
                                                        :
                                                        <td className='font-sarabun'>{data.Event_DateTimeStamp_InActive}</td>
                                                }
                                                <td className='font-sarabun'>{data.Event_Source}</td>
                                                {/* <td className='font-sarabun'>{data.Event_Tagname}</td> */}
                                                <td className='font-sarabun'>{data.Event_Category}</td>
                                                <td className='font-sarabun'>
                                                    {
                                                        data.Event_Class !== "Info" && data.Event_Class !== "Recover" ?
                                                            data.Event_Status ?
                                                                "Active"
                                                                :
                                                                "InActive"
                                                            :
                                                            "-"
                                                    }
                                                </td>
                                                <td className='font-sarabun'>
                                                    {
                                                        data.Event_Class !== "Info" && data.Event_Class !== "Recover" ?
                                                            data.Ack_Req ?
                                                                data.Ack_Status ?
                                                                    "Ack. Pending"
                                                                    :
                                                                    <>
                                                                        <p className='mb-1'>Acked.-{data.Ack_by}</p>
                                                                        <p className='mb-1'>{data.Ack_Time}</p>
                                                                    </>
                                                                :
                                                                "Not Required"
                                                            :
                                                            "-"
                                                    }
                                                </td>
                                                <td className='font-sarabun'>
                                                    <i className={'fas fa-info-circle pe-2 text-blue remark-flags ' + (data.Remark === "" ? "d-none" : "")} onClick={() => { setRemark_display_id(remark_display_id === "" ? data.Event_ID : "") }}></i>
                                                    {data.Message_Str}
                                                    <div className={'mt-1 mb-0 ' + (remark_display_id === data.Event_ID && data.Remark !== "" ? "" : "d-none")}>
                                                        <b>Remark:</b>
                                                        <p className='mt-1 mb-1'>{data.Remark}</p>
                                                    </div>
                                                </td>
                                                {
                                                    props.permitdata !== undefined ?
                                                        props.permitdata.user_role !== "Viewer" ?
                                                            <td className='font-sarabun column-action'>
                                                                {
                                                                    data.Event_Class !== "Info" && data.Event_Class !== "Recover" ?
                                                                        <i className='fas fa-pen cursor-pointers events-action' onClick={() => { setRemark_item(data); setModal_remark(true) }}></i>
                                                                        :
                                                                        null
                                                                }
                                                            </td>
                                                            :
                                                            null
                                                        : null
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {
                        modal_remark ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-pen"></i> Event Remarker</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_remark(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formremarkRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="event_id">Event ID</label>
                                                                <input type="text" className="form-control" name="event_id" value={remark_item.Event_ID} disabled />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="tag_name">Tag Name</label>
                                                                <input type="text" className="form-control" name="tag_name" value={remark_item.Event_Tagname} disabled />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="event_class">Event Class</label>
                                                                <input type="text" className="form-control" name="event_class" value={remark_item.Event_Class} disabled />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="category">Event Category</label>
                                                                <input type="text" className="form-control" name="category" value={remark_item.Event_Category} disabled />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label htmlFor="remark">Remark Text</label>
                                                                <textarea type="text" className="form-control" name="remark" rows={3} value={remark_item.Remark} onChange={(e) => {
                                                                    setRemark_item({
                                                                        ...remark_item,
                                                                        Remark: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_remark(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_saveremark() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                </div>
            </div>
            <ScrollToTopButton />
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default HistoricalAlarm